class DeliveryTime extends HTMLElement {
    constructor() {
        super();

        this.formatString = this.getAttribute("data-frm-day");
        this.excludedDays = this.getAttribute("data-exclude-day")
            .replace(/ /g, '')
            .split(",");
        this.numbDateStart = parseInt(this.getAttribute("data-estimate-start"));
        this.numbDateEnd = parseInt(this.getAttribute("data-estimate-end"));
        this.targetTime = this.getAttribute("data-time");

        this.hr = this.querySelector('.productView-dlvr__remaining-hr');
        this.mins = this.querySelector('.productView-dlvr__remaining-mins');
        this.iso_code = document.documentElement.lang;

        // Sia: paragraful cu numaratoarea, pastrat ca sa il putem inlocui cand coletul nu mai pleaca azi.
        const hourEl = this.querySelector('[data-hour-delivery]');
        this.countdownParagraph = hourEl ? hourEl.closest('p') : null;

        this.render();
        this.style.display = "block";

        setInterval(() => {
            if (this.shipsToday && this.isAfterCutoff(this.targetTime)) {
                this.render();
                return;
            }
            this.updateCountdown();
        }, 1000);
    }

    // Sia: estimarea se calculeaza in zile lucratoare, pornind de la ziua in care pleaca efectiv coletul.
    render() {
        const now = new Date();
        this.shipDate = this.getShipDate(now);
        this.shipsToday = this.shipDate.toDateString() === now.toDateString();

        if (!this.shipsToday && this.countdownParagraph) {
            const shipLabel = this.formatDate(this.shipDate, this.formatString);
            this.countdownParagraph.innerHTML = `<strong>Comanda ta pleacă ${shipLabel.replace(/^./, (c) => c.toLowerCase()).replace(/\.$/, '')}.</strong>`;
        }

        this.productDeliveryTime();
        this.updateCountdown();
    }

    updateCountdown() {
        if (!this.shipsToday) return;
        const countdown = this.countdownToTime(this.targetTime);
        if (this.hr) this.hr.innerHTML = countdown.hours;
        if (this.mins) this.mins.innerHTML = countdown.minutes;
    }

    isExcludedDay(date) {
        const code = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'][date.getDay()];
        return this.excludedDays.includes(code);
    }

    getShipDate(now) {
        const ship = new Date(now);
        if (this.isExcludedDay(ship) || this.isAfterCutoff(this.targetTime)) {
            ship.setDate(ship.getDate() + 1);
        }
        while (this.isExcludedDay(ship)) ship.setDate(ship.getDate() + 1);
        return ship;
    }

    addBusinessDays(fromDate, days) {
        const date = new Date(fromDate);
        let remaining = days;
        while (remaining > 0) {
            date.setDate(date.getDate() + 1);
            if (!this.isExcludedDay(date)) remaining--;
        }
        return date;
    }

    productDeliveryTime() {
        const orderDlvr = document.querySelectorAll("[data-delivery-time]");
        if (orderDlvr.length === 0) return;

        const formattedStartDate = this.formatDate(this.addBusinessDays(this.shipDate, this.numbDateStart), this.formatString);
        const formattedEndDate = this.formatDate(this.addBusinessDays(this.shipDate, this.numbDateEnd), this.formatString);

        orderDlvr.forEach(el => {
            const startEl = el.querySelector('[data-start-delivery]');
            const endEl = el.querySelector('[data-end-delivery]');

            if (startEl) startEl.innerHTML = formattedStartDate;
            if (endEl) endEl.innerHTML = formattedEndDate;
        });
    }

    formatDate(dateString, formatString) {
        const date = new Date(dateString);
        const locale = this.iso_code || document.documentElement.lang || 'en-US';
        const dayOfWeek = date.toLocaleDateString(locale, { weekday: 'long' }).replace(/^./, (c) => c.toUpperCase()),
            dayOfMonth = date.toLocaleDateString(locale, { day: '2-digit' }),
            month = date.toLocaleDateString(locale, { month: 'short' }),
            monthNumber = (date.getMonth() + 1).toString().padStart(2, '0'),
            year = date.toLocaleDateString(locale, { year: 'numeric' });

        const formattedDate = formatString
            .replace('d', dayOfWeek)
            .replace('DD', dayOfMonth)
            .replace('MMM', month)
            .replace('MM', monthNumber)
            .replace('YYYY', year);

        return formattedDate;
    }

    isAfterCutoff(targetTime) {
        const now = new Date();
        const target = new Date(`${now.toDateString()} ${targetTime}`);
        return target < now;
    }

    countdownToTime(targetTime) {
        const currentTime = new Date(),
            targetTimeString = `${currentTime.toDateString()} ${targetTime}`,
            targetDateTime = new Date(targetTimeString);

        if (targetDateTime < currentTime) targetDateTime.setDate(targetDateTime.getDate() + 1);

        const remainingTime = targetDateTime - currentTime;

        const hours = Math.floor(remainingTime / (1000 * 60 * 60)),
            minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

        return { hours, minutes };
    }
}
customElements.define('delivery-time', DeliveryTime);
